import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '@app/_services';

@Injectable()
export class JwtInterceptor implements HttpInterceptor
{
	constructor(private authenticationService: AuthenticationService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
	{
		try
		{
			// add authorization header with jwt token if available
			let currentUser = this.authenticationService.currentUserValue;
			let token = currentUser?.token;
			// fallback to persisted auth if in-memory state was reset
			if (!token)
			{
				const currentUserRaw = localStorage.getItem('currentUser');
				if (currentUserRaw)
				{
					try
					{
						const persistedUser = JSON.parse(currentUserRaw);
						token = persistedUser?.token;
					}
					catch (e)
					{
						// ignore malformed local storage and continue without auth header
					}
				}
			}


			const headers: { [key: string]: string } = {};

			if (token)
			{
				headers['Authorization'] = `Bearer ${ token }`;
			}

			const uid = localStorage.getItem('deviceUid');
			if (uid)
			{
				headers['uid'] = uid;
			}

			if (Object.keys(headers).length > 0)
			{
				request = request.clone({ setHeaders: headers });
			}

			return next.handle(request);
		} catch (error)
		{
			console.log('Error(intercept): ' + error);
			return next.handle(request);
		}
	}
}
